type EasingFunction = (t: number) => number;

export class NumberAnimation {
    #startValue: number;
    #endValue: number;
    #duration: number;
    #easing: EasingFunction;

    constructor(startValue: number, endValue: number, duration: number, easing: EasingFunction) {
        this.#startValue = startValue;
        this.#endValue = endValue;
        this.#duration = duration;
        this.#easing = easing;
    }

    start(onUpdate: (value: number) => void, onComplete: () => void): void {
        const startTime = performance.now();
        const endTime = startTime + this.#duration;

        const update = () => {
            const currentTime = performance.now();
            const progress = (currentTime - startTime) / this.#duration;
            const value =
                this.#startValue + (this.#endValue - this.#startValue) * this.#easing(progress);

            onUpdate(value);

            if (currentTime >= endTime) {
                onComplete();
            } else {
                requestAnimationFrame(update);
            }
        };

        requestAnimationFrame(update);
    }
}

export const LinearEasing: EasingFunction = (t) => t;
export const EaseInOutEasing: EasingFunction = (t) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
